export const data = [
  {
    locked: false,
    layers: {
      ROOT: {
        type: { resolvedName: 'RootLayer' },
        props: {
          boxSize: { width: 1640, height: 924 },
          position: { x: 0, y: 0 },
          rotate: 0,
          color: 'rgb(255, 255, 255)',
          image: null,
        },
        locked: false,
        child: [
          '35b18a84-6a91-4fc0-89bf-05b2769c3179',
          '6b774af9-623d-41b7-9daa-fa7f392be460',
          'fb5dfcaf-65c8-4ce1-90f4-23ab1e65052b',
          '812d60e6-fa51-43f6-ac5e-53a536d5a74b',
          '1e68d85b-0be1-40de-b63b-2f394ce622e2',
        ],
        parent: null,
      },
      '35b18a84-6a91-4fc0-89bf-05b2769c3179': {
        type: { resolvedName: 'ShapeLayer' },
        props: {
          shape: 'rectangle',
          position: { x: -41, y: 652 },
          boxSize: { width: 1766, height: 296, x: -41, y: 652 },
          rotate: 0,
          color: 'rgb(253, 235, 207)',
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
      '6b774af9-623d-41b7-9daa-fa7f392be460': {
        type: { resolvedName: 'TextLayer' },
        props: {
          text: '<p style="font-family: Chewy; color: rgb(0, 0, 0); font-size: 42px; text-align: center; line-height: 1.4; letter-spacing: 0em;"><strong>SAFEER</strong></p><p style="font-family: Chewy; color: rgb(0, 0, 0); font-size: 42px; text-align: center; line-height: 1.4; letter-spacing: 0;"><strong>DESIGN EDITOR</strong></p>',
          position: { x: 527.1390728476821, y: 243.582179409994 },
          boxSize: {
            width: 536.3009995574356,
            height: 196.6429861529199,
            x: 523.1390728476821,
            y: 259.9867549668875,
          },
          scale: 1.6664659843467788,
          rotate: 0,
          fonts: [
            {
              name: 'Chewy',
              fonts: [
                {
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Chewy/Chewy-Regular.woff2',
                  ],
                },
              ],
            },
          ],
          colors: ['rgb(0, 0, 0)'],
          fontSizes: [42],
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
      'fb5dfcaf-65c8-4ce1-90f4-23ab1e65052b': {
        type: { resolvedName: 'TextLayer' },
        props: {
          text: '<p style="font-family: Oswald; color: rgb(0, 0, 0); font-size: 18px; text-transform: uppercase; text-align: center; line-height: 1.4; letter-spacing: 0;"><strong>DEVELOPED WITH REACTJS</strong></p>',
          position: { x: 660.2715231788078, y: 440.2251655629139 },
          boxSize: {
            width: 261.91666666666606,
            height: 25,
            x: 660.2715231788078,
            y: 440.2251655629139,
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: 'Oswald',
              fonts: [
                {
                  style: 'Bold',
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Bold.woff2',
                  ],
                },
                {
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Regular.woff2',
                  ],
                },
              ],
            },
          ],
          colors: ['rgb(0, 0, 0)'],
          fontSizes: [18],
          effect: null,
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
      '812d60e6-fa51-43f6-ac5e-53a536d5a74b': {
        type: { resolvedName: 'TextLayer' },
        props: {
          text: '<p style="font-family: Oswald; color: rgb(0, 0, 0); margin-top: 20px;  font-size: 18px; text-transform: uppercase; text-align: center; line-height: 1.5; letter-spacing: 0;"><strong>WHATSAPP: https://wa.me/+923220919697</strong></p>',
          position: { x: 587.4569536423838, y: 839.8609271523178 },
          boxSize: {
            width: 379.3868653421627,
            height: 25,
            x: 587.4569536423838,
            y: 839.8609271523178,
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: 'Oswald',
              fonts: [
                {
                  style: 'Bold',
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Bold.woff2',
                  ],
                },
                {
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Regular.woff2',
                  ],
                },
              ],
            },
          ],
          colors: ['rgb(0, 0, 0)'],
          fontSizes: [18],
          effect: null,
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
      '1e68d85b-0be1-40de-b63b-2f394ce622e2': {
        type: { resolvedName: 'TextLayer' },
        props: {
          text: '<p style="font-family: Oswald; color: rgb(0, 0, 0); font-size: 18px; text-transform: uppercase; text-align: center; line-height: 1.5; letter-spacing: 0;"><strong>CONTACT: MSAFEERHUSSAIN@GMAIL.COM</strong></p>',
          position: { x: 634.1125827814567, y: 810.4900662251654 },
          boxSize: {
            width: 293.4994481236197,
            height: 25,
            x: 634.1125827814567,
            y: 810.4900662251654,
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: 'Oswald',
              fonts: [
                {
                  style: 'Bold',
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Bold.woff2',
                  ],
                },
                {
                  urls: [
                    'https://api-gilt-one.vercel.app/assets/liquid-editor/fonts/raw/master/src/fonts/Oswald/Oswald-Regular.woff2',
                  ],
                },
              ],
            },
          ],
          colors: ['rgb(0, 0, 0)'],
          fontSizes: [18],
          effect: null,
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
    },
  },
];
